import { RandomId } from "@swivl-mono/helpers";
import {
  NodeData_Voice,
  NodeInterface,
  NodeType,
  VoiceNodeCommandType,
  VoiceNodeCommand_Call,
  VoiceNodeCommand_Forward,
  VoiceNodeCommand_Hangup,
  VoiceNodeCommand_Media,
} from "@swivl-mono/types";
import { Dropdown, Switch } from "@swivl-mono/ui";

import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";
import { QuestsDropdown } from "../../../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";

const VoiceNode = {
  Type: NodeType.Voice,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.Voice,
      command: { type: VoiceNodeCommandType.HANGUP, message: "" } as VoiceNodeCommand_Hangup,
      goto: "", // deprecated
      // machineAnsweredGoto: "", // deprecated
      // noAnswerGoto: "", // deprecated
      // timeoutGoto: "", // deprecated
      // blockHumanInterrupts: false,
      sendDigits: "",
      amdHumanQuest: "",
      amdMachineQuest: "",
      amdFallbackQuest: "",
    } as NodeData_Voice;
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node as any,
      title: "Voice",
      body: node.command.type.toUpperCase(),
      //   baseWidth: 250,

      // tabs: []
      tabs: node.command.type === VoiceNodeCommandType.MEDIA ? [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }] : []
    });
  },

  InspectorPanel: class VoiceNodeInspectorPanelClass extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    renderCommandOptions(node: NodeData_Voice) {
      switch (node.command.type) {
        case VoiceNodeCommandType.MEDIA:
          return <div>
            <label>Media URL</label>
            <TagInput
              value={node.command.uri}
              onChange={this.onChange}
              name="command.uri"
              placeholder="https://swivl-cdn.s3-us-west-1.amazonaws.com/filibuster1.mp3"
            />
          </div>
        case VoiceNodeCommandType.CALL:
          return (
            <div>
              <label>Number to Call</label>
              <TagInput type={TagInputType.SingleLine} value={node.command.to} onChange={this.onChange} name="command.to" />
              <label>Send Digits</label>
              <TagInput type={TagInputType.SingleLine} value={node.command.sendDigits} onChange={this.onChange} name="command.sendDigits" />
              {/* <br />
              <br />
              <label>Block Human Interrupts</label>
              <Switch
                on={node.blockHumanInterrupts ?? false}
                name="blockHumanInterrupts"
                onSet={(on: boolean, name?: string) => {
                  return this.onChangeSwitch(name!, on);
                }}
              /> */}
              <br />
              <br />
              {/* <label>Outbound Quest</label>
              <QuestsDropdown value={node.outboundQuest} name="outboundQuest" onChange={this.onChange} />
              <br /> */}
              <label>Human Answered:</label>
              <QuestsDropdown value={node.amdHumanQuest} name="amdHumanQuest" onChange={this.onChange} />
              <br />
              <label>Machine Answered:</label>
              <QuestsDropdown value={node.amdMachineQuest} name="amdMachineQuest" onChange={this.onChange} />
              <br />
              <label>Unknown Answered:</label>
              <QuestsDropdown value={node.amdFallbackQuest} name="amdFallbackQuest" onChange={this.onChange} />
            </div>
          );
        case VoiceNodeCommandType.FORWARD:
          return (
            <div>
              <label>Forward To</label>
              <TagInput type={TagInputType.SingleLine} value={node.command.to} onChange={this.onChange} name="command.to" />

              <label>Pre-forward Message</label>
              <TagInput value={node.command.message} onChange={this.onChange} name="command.message" />

              <label>Send Digits</label>
              <TagInput type={TagInputType.SingleLine} value={node.command.sendDigits} onChange={this.onChange} name="command.sendDigits" />
            </div>
          );
        case VoiceNodeCommandType.HANGUP:
          return (
            <div>
              <label>Goodbye Message</label>

              <TagInput value={node.command.message} onChange={this.onChange} name="command.message" />
            </div>
          );
          break;
      }
    }

    render() {
      const node = this.props.node as NodeData_Voice;

      return (
        <div className="panel ArrayNodePanel">
          <InspectorNodeHeader title="Voice" id={node.id} />

          <Dropdown
            name="command.type"
            value={node.command.type}
            optionSelected={(option) => {
              let node = { ...this.props.node };
              switch (option.value as VoiceNodeCommandType) {
                case VoiceNodeCommandType.CALL:
                  node.command = { type: VoiceNodeCommandType.CALL, to: "" } as VoiceNodeCommand_Call;
                  break;
                case VoiceNodeCommandType.FORWARD:
                  node.command = { type: VoiceNodeCommandType.FORWARD, to: "", message: "Forwarding your call now", sendDigits: "" } as VoiceNodeCommand_Forward;
                  break;
                case VoiceNodeCommandType.HANGUP:
                  node.command = { type: VoiceNodeCommandType.HANGUP, message: "Goodbye" } as VoiceNodeCommand_Hangup;
                  break;
                case VoiceNodeCommandType.MEDIA:
                  node.command = { type: VoiceNodeCommandType.MEDIA, uri: "https://swivl-cdn.s3-us-west-1.amazonaws.com/filibuster1.mp3" } as VoiceNodeCommand_Media
              }

              this.onChangeSwitch("command", node.command);
            }}
            options={Object.values(VoiceNodeCommandType).map((type) => {
              return {
                value: type,
                label: type.charAt(0).toUpperCase() + type.slice(1),
              };
            })}
          />

          {this.renderCommandOptions(node)}

          <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
        </div>
      );
    }
  },
};
export default VoiceNode;
